import { render, staticRenderFns } from "./modifyStock.vue?vue&type=template&id=9855fecc&scoped=true"
import script from "./modifyStock.vue?vue&type=script&lang=js"
export * from "./modifyStock.vue?vue&type=script&lang=js"
import style0 from "./modifyStock.vue?vue&type=style&index=0&id=9855fecc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9855fecc",
  null
  
)

export default component.exports